// client/src/routes/app/properties/$propertyId/repairs.tsx — SCR-PROP-003 tab „Reparații"
// (D-2840).
//
// SCR-REP-001's board with the property pinned, table view included: every repair ticket the
// apartment has had, the closed ones too. `Operations.Read`, as the board's own route.

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { RepairBoard } from '@/features/repairs/RepairBoard';
import { repairSearchSchema, type RepairSearch } from '@/features/repairs/search';

export const Route = createFileRoute('/app/properties/$propertyId/repairs')({
  validateSearch: repairSearchSchema,
  component: RepairBoardTab,
});

function RepairBoardTab() {
  const { propertyId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <RequirePermission permission="Operations.Read">
      <RepairBoard
        pinnedPropertyId={propertyId}
        search={search}
        onSearchChange={(next: (previous: RepairSearch) => RepairSearch) => {
          void navigate({ search: next });
        }}
      />
    </RequirePermission>
  );
}
